<template>
  <div
    :class="[
      startwrap ? 'startwrap' : '' ,
      endwrap ? 'endwrap' : '',
      singleDayEvent ? 'singledayevent' : '',
      'event' ,
      eventClass,
      definition ? 'definition' : ''
    ]"
    :style="{
      'grid-row': gridRow,
      'grid-column': gridColumn,
      'align-self': align,
      'border-left-color': color,
      'background-color': backgroundColor,
      color: textColor
    }"
  >{{name}}</div>
</template>
<script>
export default {
  name: "TimetableEvent",
  data() {
    return {};
  },
  props: {
    gridRow: {
      type: String
    },
    gridColumn: {
      type: String
    },
    name: {
      required: true,
      type: String
    },
    align: {
      type: String,
      default: "end"
    },
    color: {
      type: String
    },
    backgroundColor: {
      type: String
    },
    textColor: {
      type: String
    },
    wrapsFrom: {
      type: String
    },
    singleDayEvent: {
      type: Boolean
    },
    eventClass: {
      type: String
    },
    definition: {
      type: Boolean
    }
  },
  methods: {},
  computed: {
    startwrap: function() {
      if (this.wrapsFrom === "start" || this.wrapsFrom === "both") {
        return true;
      } else {
        return false;
      }
    },
    endwrap: function() {
      if (this.wrapsFrom === "end" || this.wrapsFrom === "both") {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped>
.event {
  border-left-width: 3px;
  padding: 7px 10px;
  margin: 6px;
  border-left-style: solid;
  font-size: 14px;
  position: relative;
  border-radius: 0 5px 5px 0;
  background-color: rgba(0, 0, 0, 0.1);
  white-space: nowrap;
  font-size: 0.84em;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.endwrap {
  margin-right: 0;
  border-radius: 0;
}

.endwrap.definition,
.startwrap.definition {
  border-radius: 0 5px 5px 0;
}

.startwrap {
  margin-left: 0;
  border-left-width: 0px;
}

.singledayevent {
  margin-left: 6px;
  border-radius: 5px;
  border-left-width: 0px;
}

.blue {
  border-color: #60a3fa;
  background-color: rgba(118, 176, 252, 0.5);
  color: #0c3264;
}

.green {
  background-color: rgba(10, 225, 30, 0.5);
}

.red {
  background-color: rgba(255, 54, 54, 0.6);
}

.definition {
  flex: 0 0 auto;
  grid-area: none !important;
  margin: 0;
}
</style>
